document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const catalogSwiperMedia = window.matchMedia('(max-width: 749px)');
const catalogSwiperInstances = new WeakMap();

function loadCatalogSwiper() {
  if (window.Swiper) return Promise.resolve(window.Swiper);
  if (window.blisbondCatalogSwiperPromise) return window.blisbondCatalogSwiperPromise;

  window.blisbondCatalogSwiperPromise = new Promise((resolve, reject) => {
    if (!document.querySelector('[data-catalog-swiper-styles]')) {
      const stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.css';
      stylesheet.dataset.catalogSwiperStyles = '';
      document.head.appendChild(stylesheet);
    }

    const existingScript = document.querySelector('[data-catalog-swiper-script]');
    if (existingScript) {
      existingScript.addEventListener('load', () => resolve(window.Swiper), { once: true });
      existingScript.addEventListener('error', reject, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.js';
    script.dataset.catalogSwiperScript = '';
    script.onload = () => resolve(window.Swiper);
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return window.blisbondCatalogSwiperPromise;
}

function updateCatalogSwipers(scope = document) {
  const sliders = scope.querySelectorAll('[data-catalog-highlights]');

  sliders.forEach((slider) => {
    const currentInstance = catalogSwiperInstances.get(slider);

    if (!catalogSwiperMedia.matches) {
      if (currentInstance) {
        currentInstance.destroy(true, true);
        catalogSwiperInstances.delete(slider);
      }
      return;
    }

    if (currentInstance) return;

    loadCatalogSwiper().then((Swiper) => {
      if (!Swiper || !slider.isConnected || !catalogSwiperMedia.matches) return;

      const instance = new Swiper(slider, {
        loop: slider.dataset.swiperLoop === 'true',
        slidesPerView: Number(slider.dataset.swiperSlidesPerView),
        spaceBetween: Number(slider.dataset.swiperSpaceBetween)
      });
      catalogSwiperInstances.set(slider, instance);
    });
  });
}

updateCatalogSwipers();
catalogSwiperMedia.addEventListener('change', () => updateCatalogSwipers());

document.addEventListener('shopify:section:load', (event) => {
  updateCatalogSwipers(event.target);
});

const catalogMenuMedia = window.matchMedia('(max-width: 749px)');

function updateCatalogMenuAccordions(scope = document) {
  const accordions = scope.querySelectorAll('[data-catalog-menu-accordion]');

  accordions.forEach((accordion) => {
    if (catalogMenuMedia.matches) {
      accordion.removeAttribute('open');
    } else {
      accordion.setAttribute('open', '');
    }
  });
}

updateCatalogMenuAccordions();
catalogMenuMedia.addEventListener('change', () => updateCatalogMenuAccordions());

document.addEventListener('shopify:section:load', (event) => {
  updateCatalogMenuAccordions(event.target);
});

const catalogCategoryAnimations = new WeakMap();
const catalogReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function setCatalogCategory(category, expanded) {
  const summary = category.querySelector('summary');
  const panel = category.querySelector('.catalog-intro__submenu');
  if (!summary || !panel) return;
  const from = category.open ? panel.getBoundingClientRect().height : 0;
  const previous = catalogCategoryAnimations.get(category);
  if (previous) {
    previous.onfinish = null;
    previous.cancel();
  }
  category.dataset.expanded = String(expanded);
  summary.setAttribute('aria-expanded', String(expanded));
  if (!expanded && panel.contains(document.activeElement)) summary.focus();
  panel.inert = !expanded;
  category.open = true;
  const to = expanded ? panel.scrollHeight : 0;
  const finish = () => {
    category.open = expanded;
    panel.style.removeProperty('overflow');
    catalogCategoryAnimations.delete(category);
  };
  if (catalogReducedMotion.matches || typeof panel.animate !== 'function' || from === to) {
    finish();
    return;
  }
  panel.style.overflow = 'hidden';
  const animation = panel.animate(
    [{ height: from + 'px' }, { height: to + 'px' }],
    { duration: expanded ? 240 : 190, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
  );
  catalogCategoryAnimations.set(category, animation);
  animation.onfinish = finish;
}

function initializeCatalogCategories(scope = document) {
  scope.querySelectorAll('[data-catalog-category]').forEach((category) => {
    if (category.dataset.expanded !== undefined) return;
    category.removeAttribute('name');
    category.dataset.expanded = 'false';
    category.open = false;
    category.querySelector('summary').setAttribute('aria-expanded', 'false');
    category.querySelector('.catalog-intro__submenu').inert = true;
  });
}

initializeCatalogCategories();
document.addEventListener('shopify:section:load', (event) => initializeCatalogCategories(event.target));
document.addEventListener('click', (event) => {
  const summary = event.target.closest('[data-catalog-category] > summary');
  if (!summary) return;
  event.preventDefault();
  const category = summary.parentElement;
  const expanded = category.dataset.expanded !== 'true';
  if (expanded) {
    category.closest('.catalog-intro__menu').querySelectorAll('[data-catalog-category]').forEach((other) => {
      if (other !== category && other.dataset.expanded === 'true') setCatalogCategory(other, false);
    });
  }
  setCatalogCategory(category, expanded);
});
